<template>
    <b-modal hide-footer id="ModalLimiteDispositivos" title="Limite de dispositivos conectados excedido" @hide="fechar">
        <div>
          <div class="text-center p-0 p-md-5">
            <img :src='urlS3+"img/deslogado-limite-dispositivos-b2b.png"' alt="ícone aceite de termos" style="max-width:200px" />
            <p class="h5 mt-4">Ops, a sua conta  excedeu o limite de três dispositivos conectados simultaneamente. Para a sua segurança, este aparelho foi desconectado.</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <button @click="fechar" type="button" class="btn btn-primary mr-3 btn-login">Fazer login</button>
            </div>
          </div>
        </div>
    </b-modal>
</template>

<script>

import LoginUtils from '@/core/utils/login-utils'

export default {
  name: 'ModalLimiteDispositivos',
  data () {
    return {
      urlS3: process.env.VUE_APP_BASE_FILES_URL
    }
  },
  mounted () {
    let motivoLogoutForcado = LoginUtils.getMotivoDispositivosLogoutForcado()
    if (motivoLogoutForcado) {
      this.$bvModal.show('ModalLimiteDispositivos')
    }
    LoginUtils.removeMotivoDispositivosLogoutForcado()
  },
  methods: {
    fechar () {
      if (this.$configEmpresa.urlRedicionamentoLogoutForcado) {
        window.location = this.$configEmpresa.urlRedicionamentoLogoutForcado
      }
      this.$bvModal.hide('ModalLimiteDispositivos')
    }
  }
}
</script>
